import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
  },
  mutations: {
    setToken (state, _token) {
      state.token = _token
      try {
        localStorage.setItem('token', _token)
      } catch (err) { }
    },
    setUserInfo (state, _info) {
      state.userInfo = _info
      try {
        localStorage.setItem('userInfo', JSON.stringify(_info))
      } catch (err) { }
    }
  },
  getters:
    {
      token: state => state.token,
      userInfo: state => state.userInfo
    }

})



// WEBPACK FOOTER //
// ./src/store/index.js